/* Built In Imports */
/* External Imports */
import { Box } from '@chakra-ui/react';
import SimpleButton from '@components/Buttons/SimpleButton';
import SectionTitle from '@components/Headings/SectionTitle';
import SingleLineText from '@components/UI/SingleLineText';
import PracticeCurriculumCard from '../components/Card/PracticeCurriculumCard';
/* Internal Imports */
/* Components */

/**
 * Returns the BenefitsGroup.
 * @param {Object} sectionContent - Content from API
 * @param {string} language - Language of the page
 * @param {string} region - Region of the page
 * @returns {ReactElement} Banner component
 * 
 */
const PracticeCurriculum = ({ pageData, sectionContent, region, language }) => {
    console.log("section content in practice curriculum is", sectionContent)
    const pageName = pageData?.pageConfig?.pageName

    return (
        <Box marginTop={{ sm: "", base: "", md: "0px" }} >
            {sectionContent.map((section, index) => {
                if (section?._modelApiKey === 'section_title') {
                    return (
                        <Box key={index}>
                            <SectionTitle
                                titleObj={section}
                                titleDecoration={"none"}
                                color="black"
                                mx={{ base: '17px', md: 'auto' }}
                            />
                        </Box>
                    );
                }
                if (section?._modelApiKey === 'single_line_text') {
                    return (
                        <Box marginTop={{ base: "-40px", sm: "-40px", md: "-45px" }}
                            width={{ sm: "305px", base: "305px", md: "437px" }}
                            mx={"auto"}  >
                            <SingleLineText fontSize="18px" textAlign="center" color="#262626" sectionContent={section} />
                        </Box>
                    )
                }

                if (section?._modelApiKey === 'card_custom_card_group') {
                    return (
                        <Box
                            maxWidth={{ base: "320px", sm: "320px", xl: "1060px" }}
                            mx={"auto"}
                        >
                            <PracticeCurriculumCard
                                sectionContent={section}
                                pageData={pageData}
                                pageName={pageName}
                            />
                        </Box>
                    )
                }
                if (section?._modelApiKey === 'simple_button') {
                    return (
                        <Box key={index}
                            paddingTop={{ base: "20px", sm: "20px", md: "50px", lg: "50px" }}
                        // marginTop={{ base: "100px", sm: "100px", md: "50px", lg: "430px" }}

                        >
                            <SimpleButton
                                pageConfig={pageData?.pageConfig}
                                style={section}
                                region={region}
                                lang={language}
                                mx="auto"
                                width={"188px"}
                            />
                        </Box>
                    )
                }
            })}
        </Box>

    );
};

export default PracticeCurriculum;
